module.exports = __webpack_public_path__ + "img/ilpa-2023-curriculo.0f84e0e7.jpeg";